import { render } from "./fullBreakdown.vue?vue&type=template&id=3d2b60ce"
import script from "./fullBreakdown.vue?vue&type=script&lang=js"
export * from "./fullBreakdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__